module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Tipo de Requisição")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.name),
      expression: "requestType.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.requestType.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requestType, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.description),
      expression: "requestType.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.requestType.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requestType, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.active),
      expression: "requestType.active"
    }],
    attrs: {
      "id": "active",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.requestType.active) ? _vm._i(_vm.requestType.active, null) > -1 : (_vm.requestType.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.requestType.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.requestType, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.requestType, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.requestType, "active", $$c)
        }
      }
    }
  })]), _vm._v(" "), (_vm.requestType.owner && _vm.requestType.owner.username) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "owner"
    }
  }, [_vm._v("Proprietário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.owner.username),
      expression: "requestType.owner.username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "owner",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.requestType.owner.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requestType.owner, "username", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Salvar\n      ")]), _vm._v(" "), (_vm.requestType.objectId) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "btn-remove"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("\n        Remover\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n        Cancelar\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.requestType.objectId) ? _c('form-section-list', {
    attrs: {
      "reqType": _vm.requestType.objectId
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01377856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestTypeDetail.vue
// module id = 1428
// module chunks = 1